export let ENTITY_ID_ORGANIZATIONS = 1;
export let ENTITY_ID_USER = 2;
export let ENTITY_ID_ROLE = 3;
export let ENTITY_ID_AUDIT_LOGS = 4;
export let ENTITY_ID_DESIGNATION = 5;
export let ENTITY_ID_WORKER = 6;
export let ENTITY_ID_DEALER = 7;
export let ENTITY_ID_BRANCH = 8;
export let ENTITY_ID_ATTENDANCE = 9;
export let ENTITY_ID_VEHICLE_MODEL = 10;
export let ENTITY_ID_ADVISORS = 11;
export let ENTITY_ID_TREATMENT = 12;
export let ENTITY_ID_JOB_CARD = 13;
export let ENTITY_ID_WATER_WASH = 14;


// Not in DB
export let ENTITY_ID_PERMISSIONS = 9999;

